// extracted by mini-css-extract-plugin
export var divider = "_2y-0";
export var dividerText = "_2y-1";